import React, { useEffect, useState } from "react";
import { Row, Col, Form, Select, Input, message, Button } from "antd";
import { fetchPincode } from "../pincode/FetchPincode";
import { fetchStates } from "../state/FetchStates";
import { fetchCities } from "../city/FetchCities";
import { fetchCountries } from "../country/FetchCountries";
import { useSelector } from "react-redux";
import { selectBaseUrl, selectProdTestUrl } from "../../redux/slices/envSlice";

const CustomerAddress = ({
  isCustomerDetail,
  handleCustomerAddressModalCancel,
  handleAddressModalCancel,
  selectedCustomerProfile,
}) => {
  const baseUrl = useSelector(selectBaseUrl);
  const prodTestUrl = useSelector(selectProdTestUrl);
  const isUser = useSelector((state) => state.user.user);
  const [form] = Form.useForm();
  const [pincode, setPincodes] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [countries, setCountries] = useState([]);

  useEffect(() => {
    const getGlobalData = async () => {
      try {
        await fetchPincode(setPincodes, baseUrl, prodTestUrl);
        await fetchStates(setStates, baseUrl, prodTestUrl);
        await fetchCities(setCities, baseUrl, prodTestUrl);
        await fetchCountries(setCountries, baseUrl, prodTestUrl);
      } catch (error) {
        message.error("Failed to fetch address data.");
      }
    };

    getGlobalData();
  }, []);

  const handleOnFinish = async (values) => {
    const data = {
      customer_id: selectedCustomerProfile
        ? selectedCustomerProfile
        : isCustomerDetail.id,
      created_by: isUser.id,
      address_identifier: values.address_identifier,
      country: values.country,
      state: values.state,
      city: values.city,
      pincode: values.pincode,
      apartment_road_area: values.apartment_road_area,
      house_flat_floor_no: values.house_flat_floor_no,
      status: "enable",
    };

    try {
      const response = await fetch(
        `${
          prodTestUrl ? prodTestUrl : baseUrl
        }/api/admin-customers-create-location/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      if (response.ok) {
        message.success("Location created successfully");
        form.resetFields();
        if (handleCustomerAddressModalCancel) {
          handleCustomerAddressModalCancel();
        }

        if (handleAddressModalCancel) {
          handleAddressModalCancel();
        }
      } else {
        const errorData = await response.json();
        message.error(
          `Failed to create location: ${errorData.message || "Unknown error"}`
        );
      }
    } catch (error) {
      message.error("An error occurred while creating location");
    }
  };

  return (
    <Form form={form} layout="vertical" onFinish={handleOnFinish}>
      <Form.Item
        label="Address Label (e.g., home/office)"
        name="address_identifier"
        rules={[{ required: true, message: "Please enter address label" }]}
        style={{ width: "100%" }}
      >
        <Input placeholder="Enter address label" style={{ width: "100%" }} />
      </Form.Item>
      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Country"
            name="country"
            rules={[{ required: true, message: "Please select country" }]}
          >
            <Select placeholder="Select country">
              {countries.map((country) => (
                <Select.Option key={country.id} value={country.id}>
                  {country.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="State"
            name="state"
            rules={[{ required: true, message: "Please select state" }]}
          >
            <Select placeholder="Select state">
              {states.map((state) => (
                <Select.Option key={state.id} value={state.id}>
                  {state.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="City"
            name="city"
            rules={[{ required: true, message: "Please select city" }]}
          >
            <Select placeholder="Select city">
              {cities.map((city) => (
                <Select.Option key={city.id} value={city.id}>
                  {city.name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Pincode"
            name="pincode"
            rules={[{ required: true, message: "Please select pincode" }]}
          >
            <Select placeholder="Select pincode">
              {pincode.map((code) => (
                <Select.Option key={code.id} value={code.id}>
                  {code.pin}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Area"
            name="apartment_road_area"
            rules={[{ required: true, message: "Please enter area" }]}
          >
            <Input placeholder="Enter area" />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="House/Flat"
            name="house_flat_floor_no"
            rules={[{ required: true, message: "Please enter house/flat" }]}
          >
            <Input placeholder="Enter house/flat" />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item style={{ textAlign: "center" }}>
        <Button type="primary" style={{ marginRight: "8px" }} htmlType="submit">
          Save
        </Button>
        <Button onClick={() => form.resetFields()}>Cancel</Button>
      </Form.Item>
    </Form>
  );
};

export default CustomerAddress;